<template>
  <div>
    <a-select
      v-model="keyword"
      showSearch
      placeholder="按关键字搜索"
      style="width: 100%"
      :defaultActiveFirstOption="false"
      :showArrow="false"
      :filterOption="false"
      @search="remoteMethod"
      @change="selectChang"
      :notFoundContent="null"
    >
      <a-select-option
        v-for="(item, index) in searchArr"
        :key="'a' + index"
        :label="item.label"
        :value="item.value"
      >
        {{ item.label }}</a-select-option
      >
    </a-select>
    <div class="mapContent" id="mapDiv"></div>
  </div>
</template>
<script>
import coordtransform from "coordtransform";
export default {
  props: ["addrs", "maps", "createTime"],
  name: "coordinatePickTianDiTu",
  data() {
    return {
      searchArr: [],
      keyword: "",
      map: null,
      lnglat: "",
      zoom: 14,
    };
  },
  filters: {},
  mounted() {
    if (this.maps) {
      this.keyword = this.addrs.addrs;
      this.lnglat = this.addrs.lnglat;
    }
    this.$nextTick(() => {
      this.loadMap();
    });
  },
  methods: {
    // 初始化天地图
    loadMap() {
      //初始化地图对象
      this.map = new T.Map("mapDiv");
      //设置显示地图的中心点和级别(北京)
      let lng = 116.40969;
      let lat = 39.89945;
      if (this.lnglat) {
        lng = this.lnglat.split(",")[0];
        lat = this.lnglat.split(",")[1];

        let result = coordtransform.gcj02towgs84(lng, lat);

        console.log("result--->", result.join(","));

        console.log("result--->", parseInt(new Date().getTime() / 1000));
        console.log("createTime--->", this.createTime);

        // 此处是修正2024-10-18前使用高德地图的数据
        let chkDate = parseInt(new Date("2024-10-18").getTime() / 1000);
        if (chkDate > this.createTime) {
          let result = coordtransform.gcj02towgs84(lng, lat);
          lng = result[0];
          lat = result[1];
          this.$emit("change", {
            lnglat: result.join(","),
            addrs: this.keyword,
          });
        }
      }
      this.map.centerAndZoom(new T.LngLat(lng, lat), this.zoom);
      //创建缩放平移控件对象
      let control = new T.Control.Zoom();
      //添加缩放平移控件
      this.map.addControl(control);
      this.addMapClick();
      if (this.lnglat) {
        this.setMarker(lng, lat);
      }
    },
    // 搜索地点
    remoteMethod(keyword) {
      var config = {
        pageCapacity: 10, //每页显示的数量
        onSearchComplete: this.localSearchResult, //接收数据的回调函数
      };

      //创建搜索对象
      new T.LocalSearch(this.map, config).search(keyword, 4);
    },
    // 标注点
    selectChang(val, opt) {
      let lng = val.split(",")[0];
      let lat = val.split(",")[1];

      //   赋值选中点
      this.lnglat = val;
      this.keyword = opt.componentOptions.propsData.label;
      this.$emit("change", {
        lnglat: this.lnglat,
        addrs: this.keyword,
      });
      this.setMarker(lng, lat);
    },
    //创建标注对象
    setMarker(lng, lat) {
      console.log("lng---->", lng);
      console.log("lat---->", lat);

      this.map.clearOverLays();
      let marker = new T.Marker(new T.LngLat(lng, lat));
      //向地图上添加标注
      this.map.addOverLay(marker);
      marker.enableDragging();
      marker.addEventListener("dragend", this.getDrageLocation);
      this.map.centerAndZoom(new T.LngLat(lng, lat), this.zoom);
    },
    // 处理地址搜索结果
    localSearchResult(result) {
      let suggests = result.getSuggests();
      if (suggests.length) {
        this.searchArr = suggests
          .map((v) => {
            if (v) {
              return {
                label: v.name,
                value: v.lonlat,
              };
            }
          })
          .filter((ele) => ele);
      }
    },
    // 根据经纬度查询地址
    getDrageLocation(e) {
      let geocoder = new T.Geocoder();
      let that = this;
      geocoder.getLocation(
        new T.LngLat(e.lnglat.getLng(), e.lnglat.getLat()),
        (result) => {
          //   赋值选中点
          that.keyword = result.getAddress();
          that.lnglat = e.lnglat.getLng() + "," + e.lnglat.getLat();
          that.$emit("change", {
            lnglat: that.lnglat,
            addrs: result.getAddress(),
          });
        }
      );
    },
    addMapClick() {
      this.removeMapClick();
      this.map.addEventListener("click", this.mapClick);
    },
    removeMapClick() {
      this.map.removeEventListener("click", this.mapClick);
    },
    mapClick(e) {
      //   alert(e.lnglat.getLng() + "," + e.lnglat.getLat());
      this.setMarker(e.lnglat.getLng(), e.lnglat.getLat());
      this.getDrageLocation(e);
    },
  },
};
</script>
<style lang="scss" scoped>
div[aria-hidden="true"] {
  display: none !important;
}

.mapContent {
  width: 100%;
  height: 300px;
  border: 1px #dbdbdb solid;
  border-radius: 3px;
}
</style>